import { SpamState } from '@app/store/spam/types'

export const initialState: SpamState = {
  fetching: false,
  spamChecks: {},
}
